module.exports = __webpack_public_path__ + "img/gray-honourable.9e41c50e.png";